import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/app_store.svg'


const _withScopeId = n => (_pushScopeId("data-v-476e8594"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "min-h-screen bg-gray-lightShow p-5" }
const _hoisted_2 = { class: "bg-white p-5" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "items-center align-middle primary-text-18px pb-10" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "SHOWは", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "リニューアルします", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-left primary-text-14px pb-2" }, " LOCARISTA向け特別優待とは？ ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "primary-border-color pb-4 border-t-4" }, null, -1))
const _hoisted_9 = { class: "text-left text-14px" }
const _hoisted_10 = { class: "pb-10" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "pb-10" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { class: "text-left" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"pb-10\" data-v-476e8594><div class=\"primary-text-14px pb-2\" data-v-476e8594> 1.LOCARIへのユーザー登録を行う </div><hr class=\"primary-border-color pb-4 border-t-4\" data-v-476e8594><div class=\"text-14px pb-4\" data-v-476e8594> LOCARISTA向け特別優待を利用するにはLOCARIのユーザー登録が必要です。 </div><div class=\"pb-4\" data-v-476e8594><a href=\"https://locari.jp/users/sign_up\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"inline-block text-center block w-full items-center rounded-md text-white custom-button\" data-v-476e8594> LOCARIユーザー登録 </a></div><div class=\"text-12px\" data-v-476e8594> ※既にユーザー登録を行っている場合は、追加の登録は不要です </div></div>", 1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "pb-10" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "primary-text-14px pb-2" }, "2.移行コードを確認する", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "primary-border-color pb-4 border-t-4" }, null, -1))
const _hoisted_24 = {
  key: 0,
  class: "text-14px text-center font-bold600"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-14px pb-4" }, [
  /*#__PURE__*/_createTextVNode(" 移行手続きに必要な移行コードを確認します。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("あなたの移行コードは ")
], -1))
const _hoisted_27 = { class: "text-14px text-center font-bold600" }
const _hoisted_28 = { class: "pb-10" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "primary-text-14px pb-2" }, "3.移行手続きを行う", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "primary-border-color pb-4 border-t-4" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-14px pb-4" }, " 以下のサイトより移行手続きを行います。 ", -1))
const _hoisted_32 = { class: "pb-4" }
const _hoisted_33 = ["href"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-12px" }, " ※移行手続きにはLOCARIへのログインが必要です ", -1))
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<div class=\"pb-10\" data-v-476e8594><div class=\"primary-text-14px pb-2\" data-v-476e8594> 4.LOCARIアプリをインストールする </div><hr class=\"primary-border-color pb-4 border-t-4\" data-v-476e8594><div class=\"text-14px pb-4\" data-v-476e8594> 特別優待を利用するためにはLOCARIアプリのインストールが必要となります。<br data-v-476e8594> 以下のサイトよりアプリのインストールを行います。 </div><div class=\"pb-4 text-center\" data-v-476e8594><a href=\"https://app.adjust.com/ttwx0t\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"inline-block\" data-v-476e8594><img src=\"" + _imports_0 + "\" alt=\"app store\" data-v-476e8594></a></div><div class=\"text-12px\" data-v-476e8594> ※現在iOS版のみ対応しております。Android版はリリースまで暫くお待ちください。 </div></div><div class=\"text-14px\" data-v-476e8594> 特別優待機能はリニューアル後から使用可能となります。<br data-v-476e8594> リニューアル完了は11月1日を予定しております。完了後に再度お知らせ致しますのでしばらくお待ち下さい。 </div>", 2)
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<div class=\"text-14px\" data-v-476e8594><div class=\"primary-text-14px pb-2\" data-v-476e8594> 2.LOCARISTAへの登録申請を行う </div><hr class=\"primary-border-color pb-4 border-t-4\" data-v-476e8594><div class=\"text-14px pb-4\" data-v-476e8594> 以下のサイトよりLOCARISTAへの登録申請を行います。 </div><div class=\"pb-4\" data-v-476e8594><a href=\"https://locari.jp/locarista/apply\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"inline-block text-center block w-full items-center rounded-md text-white custom-button\" data-v-476e8594> 登録申請 </a></div><div class=\"text-12px\" data-v-476e8594> ※手続きにはLOCARIへのログインが必要です </div></div>", 1)
const _hoisted_39 = [
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_P = _resolveComponent("P")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.migrationCodeLoaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_P, null, {
                default: _withCtx(() => [
                  _createTextVNode("LOCARISTA向け特別優待に")
                ]),
                _: 1
              }),
              _hoisted_6
            ]),
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createTextVNode(" 招待と審査を通過したインフルエンサーである「LOCARISTA」会員様向けに特別にご用意した優待を提供するサービスです。 "),
                (_ctx.migrationCode !== undefined)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, " SHOWのユーザーの皆様はLOCARISTAとして、今まで通り特別優待をご利用することができます。 "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, [
                (_ctx.migrationCode != undefined)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createTextVNode(" 引き続き特別優待を利用するためにはデータの移行が必要です。"),
                      _hoisted_14,
                      _createTextVNode(" 以下の手順に従って移行手続きを行って下さい。"),
                      _hoisted_15,
                      _createTextVNode(" ※現在リニューアルに伴う移行期間中です。特別優待機能はリニューアル完了後にご利用いただけます。 ")
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createTextVNode(" 特別優待の利用を希望する場合は以下の手順に従って登録をお願い致します。"),
                      _hoisted_17,
                      _createTextVNode(" ※現在リニューアルに伴う移行期間中です。特別優待機能はリニューアル完了後にご利用いただけます。 ")
                    ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              (_ctx.migrationCode !== undefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _hoisted_23,
                      (_ctx.migrationCodeError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, " 移行コードの取得に失敗しました。 "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _hoisted_26,
                            _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.migrationCode), 1)
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _hoisted_30,
                      _hoisted_31,
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("a", {
                          href: `https://locari.jp/locarista/transfer?code=${_ctx.migrationCode}`,
                          target: "_blank",
                          rel: "noopener noreferrer",
                          class: "inline-block text-center block w-full items-center rounded-md text-white custom-button"
                        }, " 移行手続き申請 ", 8, _hoisted_33)
                      ]),
                      _hoisted_34
                    ]),
                    _hoisted_35
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}